import {createAsyncThunk} from '@reduxjs/toolkit'
import {getFinalizationLink} from 'business/bofhLinks'
import {getHttpRequestId} from 'modules/common/selectors'
import {getIsOfferCheckExistingBookingValid} from 'modules/offerCheck/selectors'
import {getCurrentBookingRequestId} from 'utils/bookingRequestId'

import {
  bookApi,
  FINALIZE_BOOKING_CACHE_KEY
} from '@vio/core/src/booking/services/bookApi'
import {getBovioApiKey} from '@vio/core/src/experiments/modules/selectors'

import {RootState} from '../../../store'
import {getIsChargeLaterBookingCreation, getThreeDSContext} from '../selectors'
import {startFinalization} from '../slice'

export const handlePsd2Success = createAsyncThunk<
  void,
  void,
  {state: RootState}
>('bookingCreation/handlePsd2Success', async (_arg, {dispatch, getState}) => {
  const state = getState()

  // Same check the submit uses to pick the booking payment link over creation
  const isExistingBooking = getIsOfferCheckExistingBookingValid(state)
  const threeDSContext = getThreeDSContext(state)

  const isChargeLaterBookingCreation = getIsChargeLaterBookingCreation(state)
  const finalizationLink = getFinalizationLink({
    isExistingBooking,
    isChargeLaterBookingCreation,
    links: threeDSContext?.bookingStatusLinks
  })

  if (!finalizationLink) return

  dispatch(startFinalization())
  dispatch(
    bookApi.endpoints.bookingFinalization.initiate(
      {
        link: finalizationLink,
        profileKey: getBovioApiKey(state),
        httpRequestId: getHttpRequestId(state) ?? '',
        bookingRequestId: getCurrentBookingRequestId(),
        clientUserAgent: `checkout/${process.env.NEXT_PUBLIC_APP_VERSION}`
      },
      {fixedCacheKey: FINALIZE_BOOKING_CACHE_KEY}
    )
  )
})
